import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { SessionInfo } from '../session/SessionInfo';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { NotificationService, LoaderService, ErrorService, } from "../../shared/session/index";
import { IMenuParametro, MenuParametro } from "./header.model";
import * as moment from 'moment';
import { ModuleService } from 'src/app/modules/security/modules/shared/module.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Output() onSearchEmit: EventEmitter<any> = new EventEmitter();
  @Input() from: number;
  codUsuario: string;
  urlFoto: string;
  nomApellidos: string;
  perfiles: any;
  fecActivacion: any;
  pickedModule: number;
  versionAngular: string = environment.versionAngular;
  versionAppWeb: string = environment.versionAppWeb;
  menuParametro: IMenuParametro;
  dataResult: any;
  totalRegistros: any;
  msgErrorGet: string;
  empresaName: string;
  firebaseData: any;
  logoEmpresa: string;
  empresaID: number;
  nivelAccesoName: string;
  entidadName: string;

  constructor(private router: Router,
    private sessionInfo: SessionInfo,
    private loaderService: LoaderService,
    private errorService: ErrorService,
    private moduleService: ModuleService,
    private notificationService: NotificationService) { }

  ngOnInit() {
    this.codUsuario = this.sessionInfo.getCodUsuario();
    if (this.codUsuario == "")
      this.goToLogin();
    this.nivelAccesoName = this.sessionInfo.getNivelAccesoName();
    this.entidadName = this.sessionInfo.getEntidadName();
    this.empresaName = this.sessionInfo.getEmpresaName();
    this.nomApellidos = this.sessionInfo.getNomApellidos();
    this.perfiles = this.sessionInfo.getPerfiles();
    this.fecActivacion = moment(this.sessionInfo.getFecActivacion()).format("DD/MM/YYYY HH:mm");
    this.menuParametro = new MenuParametro(1, "");
    this.obtenerEmpresa();
    this.consultarOrigen();
  }
  private obtenerEmpresa(): void {
    this.empresaID = this.sessionInfo.getEmpresaID()
    switch (this.empresaID) {
      case 1:
        this.logoEmpresa = 'navbar-brand'
      case 2:

        break;
      case 3:

        break;
      case 4:

        this.logoEmpresa = 'navbar-brandPiura'
        break;
      case 5:

        break;
      default:
        break;
    }
  }

  onCloseSession() {
    this.sessionInfo.delAudit();
    this.goToLogin();
  }

  goToLogin() {
    this.router.navigate(['/Login']);
  }

  consultarOrigen() {
    if (this.from == 1) {
      this.listarMenuParametros();
    }
  }

  public listarMenuParametros(): void {
    this.loaderService.show();
    this.moduleService.listarPorAcceso(
      this.sessionInfo.getIdUsuario(), this.sessionInfo.getAplicacionID(), this.sessionInfo.getIdNivelAcceso(),
      this.sessionInfo.getIdEntidad(), this.sessionInfo.getRoleID())
      .subscribe(res => {
        if (this.errorService.getMessageError(res)) {
          this.dataResult = res;
        }
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  selectedModule(moduleID: number): void {
    this.sessionInfo.setModuleID(moduleID);
    this.router.navigate(['/landingAccess']);
    this.pickedModule = moduleID;
    this.onSearchEmit.emit({ moduleID: moduleID });
  }
}
